import React from 'react';
import {Link, useHistory} from 'react-router-dom';
import {isEmpty, keys} from 'lodash';
import Autosuggest from 'react-autosuggest';
import {Button} from 'reactstrap';

import {UNABLE_TO_FIND_IMAGE_MATCHED} from 'configs';
import withAdvancedSearchInput from 'modules/advanced-search/withAdvancedSearchInput';
import {ImageFlags} from 'components/Images';
import {getCountryCodeById} from 'utils/locales';
import cx from 'classnames';
import styles from './AdvancedSearchInput.module.scss';
import useGetPublicLimit from 'modules/advanced-search/useGetPublicLimit';
import urlJoin from 'url-join';
import {removePrefix} from 'utils/string';
import {MDB_PREFIX} from 'configs';
import {alertConfirm} from 'utils/alerts';
import {useViewport} from 'contexts/ViewportContext';
import {VIEWPORT_WIDTHS} from 'configs';
import MuiIcon from 'components/Icons/MuiIcon';

const limitReachedOption = {
  type: 'warning',
  title:
    '<span class="text-nowrap">To view more company certificates, \n an account is required.</span>',
  html: `<div style="font-weight: 400">
    <p style="font-size: 14px" class="mb-1">Please log in or create a new free account to proceed.</p>
  </div>`,
  footer: `
  <div style="font-weight: 400">
    <div class="d-flex align-items-center justify-content-center mb-3">
      <a class="btn btn-outline-primary rounded mr-2" href="/login" onclick="event.preventDefault();">Log In</a>
      <a class="btn btn-primary rounded" href="/register">Sign Up</a>
    </div>
    <div>
      <p style="font-size: 14px">For unlimited access, explore our <a href="/plans">subscription plans</a>.</p>
    </div>
  </div>
  `,
  showConfirmButton: false,
  showCloseButton: true,
  showCancelButton: false,
};

const LIMIT_TYPE = {
  cert: 'cert_limit',
  ce: 'ce_limit',
};

function AdvancedSearchInputPublic(props) {
  const {stateProps, suggestionProps, verifyCaptcha, ...rest} = props;
  const {
    limit,
    isLoading: isLimitLoading,
    getLimit,
  } = useGetPublicLimit(verifyCaptcha);
  const history = useHistory();
  const {size} = useViewport();
  const isMobile = VIEWPORT_WIDTHS[size] < VIEWPORT_WIDTHS['sm'];

  const {
    searchType,
    keyword,
    suggestions,
    isLoading,
    hasSearched,
    isFocused,
    // setKeyword,
    setHasSearched,
    setIsFocused,
    // getSuggestion,
    clearSuggestions,
    clearAllStates,
    recordsCount,
  } = stateProps;
  const {
    onSuggestionsFetchRequested,
    onSuggestionsClearRequested,
    // handleSuggestionSelected,
    getSuggestionValue,
    themeGenerator,
    renderInputGenerator,
    inputProps,
  } = suggestionProps;

  const overallLoading = isLimitLoading || isLoading;

  async function onSuggestionSelected(event, {suggestion}) {
    event.preventDefault();

    if (isLimitLoading) return;

    const isCert = !!suggestion.certification_number;
    const limitData = limit[LIMIT_TYPE[searchType]];
    const {is_limit_reached, viewed_ids} = limitData;
    const ids = keys(viewed_ids);

    setHasSearched(false);
    setIsFocused(false);
    clearSuggestions();

    if (isCert) {
      const {certification_number} = suggestion;

      const isViewed = ids.includes(certification_number);

      if (isViewed || !is_limit_reached) {
        history.push(urlJoin('/certification', certification_number));
      } else {
        document.activeElement.blur();
        await alertConfirm(limitReachedOption);
        clearAllStates();
      }
    } else {
      const {company_id} = suggestion;
      const isViewed = ids.includes(company_id);

      if (isViewed || !is_limit_reached) {
        history.push(
          urlJoin('/certified-entity', removePrefix(company_id, MDB_PREFIX.ce))
        );
      } else {
        document.activeElement.blur();
        await alertConfirm(limitReachedOption);
        clearAllStates();
      }
    }
  }

  function renderSuggestion(suggestion) {
    const {company_name, countries_id} = suggestion;

    return (
      <div>
        {countries_id && (
          <div className="d-flex">
            <ImageFlags
              countryCode={getCountryCodeById(countries_id)}
              className="d-inline-block mr-2"
            />
            <span>{company_name}</span>
          </div>
        )}
        {!countries_id && (
          <div className="d-flex">
            <div className={styles['confidential-icon']}>
              <MuiIcon name="lock" style={{margin: 0, padding: 0}} />
            </div>
            <span>{company_name}</span>
          </div>
        )}
      </div>
    );
  }

  function renderSuggestionsContainer({containerProps, children}) {
    const {className, ...rest} = containerProps;

    if (overallLoading) {
      return (
        <div
          className={cx(
            className,
            styles['single-search__suggestions-container--loading']
          )}
          {...rest}
        >
          <div className="d-flex align-items-center justify-content-center h-100">
            <p className="m-auto">Loading...</p>
          </div>
        </div>
      );
    }

    if (!hasSearched && isEmpty(suggestions)) {
      return (
        <div className={className} {...rest}>
          <div className="text-center my-4">
            Please provide company name or certification number to start
            searching
          </div>

          {/* <hr className="mb-0" />
          <Row className="d-flex flex-row justify-content-center align-items-center text-left mx-5 my-4">
            <Col xs="auto">
              <img src={VERIFIED_IMAGE} alt="try" />
            </Col>

            <Col>
              <h4 className="mb-1">Start your 7-day free trial</h4>
              <span className="mb-1">
                Enjoy enhanced capabilities during your free trial, including:
              </span>
              <ul className="mb-1">
                <li>
                  <strong>Bulk Verification</strong>: Verify multiple
                  certifications simultaneously.
                </li>
                <li>
                  <strong>Watchlist Management</strong>: Monitor key
                  certifications automatically.
                </li>
                <li>
                  <strong>Real-Time Alerts</strong>: Receive instant
                  notifications on status updates.
                </li>
              </ul>
              <span className="mb-1">
                You may cancel anytime before the trial ends to avoid charges.
              </span>
            </Col>
            <Col xs={12} md="auto" className="text-center mt-2 mt-lg-0">
              <Button
                tag={Link}
                to="/register/user?subscription=free_trial"
                color="outline-primary"
              >
                Start Free Trial
              </Button>
            </Col>
          </Row> */}
        </div>
      );
    }

    if (hasSearched && isEmpty(suggestions)) {
      return (
        <div className={className} {...rest}>
          <div
            className={cx(
              styles['single-search__suggestions-container--no-results'],
              'm-3 p-4'
            )}
          >
            <img
              src={UNABLE_TO_FIND_IMAGE_MATCHED}
              alt="try"
              className="mr-3"
            />
            <div>
              <h4 className="mb-0">Unable to find matched results</h4>
              <p className="mb-0">Can't find the company you're looking for?</p>

              <p className="mb-0">
                <Link to="/enquiry" className="text-primary font-weight-bold">
                  Send a request here
                </Link>
              </p>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className={className} {...rest}>
        {children}
        <Button
          block
          outline
          color="white"
          className={cx(
            styles['single-search__suggestions-container-view-more'],
            'p-2 text-primary d-flex justify-content-start'
          )}
          type="submit"
        >
          <span className="mx-2">
            {recordsCount} record(s) found, view more results here
          </span>
        </Button>
        <hr className="m-0" />
        <div
          className={cx(
            styles['single-search__suggestions-container-view-more-v2'],
            'p-3 text-center'
          )}
        >
          <p className="mb-0">
            <Link to="/login" className="text-primary">
              Log In
            </Link>{' '}
            or{' '}
            <Link to="/register" className="text-primary">
              Sign Up
            </Link>{' '}
            to view more results.
          </p>
        </div>
      </div>
    );
  }

  const theme = themeGenerator(isFocused, false);
  const renderInputComponent = (inputProps) =>
    renderInputGenerator(
      inputProps,
      isFocused,
      false,
      isMobile
        ? {
            outline: true,
            color: 'white',
            children: (
              <MuiIcon
                name="search"
                className="text-primary"
                style={{fontSize: '24px'}}
              />
            ),
            className: 'p-0',
          }
        : undefined
    );

  const _inputProps = {
    ...inputProps,
    style: {fontSize: '18px'},
    onFocus: async () => {
      setIsFocused(true);
      if (keyword) setHasSearched(true);

      await getLimit();
    },
  };

  return (
    <Autosuggest
      theme={theme}
      alwaysRenderSuggestions
      suggestions={suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      onSuggestionSelected={onSuggestionSelected}
      getSuggestionValue={getSuggestionValue}
      inputProps={_inputProps}
      renderSuggestion={renderSuggestion}
      renderSuggestionsContainer={renderSuggestionsContainer}
      renderInputComponent={renderInputComponent}
      focusInputOnSuggestionClick={false}
      {...rest}
    />
  );
}

export default withAdvancedSearchInput(AdvancedSearchInputPublic);
